// useAuthorization.js
import { useStore } from 'vuex'
import { isString } from '@/utils/helpers'

export default function useAuthorization() {
  const store = useStore()

  const can = (permission, moduleName = null) => {
    const name = moduleName ? moduleName + '_' + permission : permission

    return store.getters.isSuperAdmin || store.getters.userPermissions[name]
  }

  const isYou = (id) => {
    return (store?.getters?.userProfile?.id ?? -1) == id
  }

  const hasRoles = (roles) => {
    if(isString(roles)){
      roles = roles.split(',').map(role => role.trim())
    }

    return store.getters.userRoles.some(role => roles.includes(role))
  }

  return {
    can,
    hasRoles,
    isYou
  }
}
